/** @jsx jsx */
import { Component, h } from 'preact'
import { useMemo } from 'preact/hooks'
import { observer } from 'mobx-react-lite'
import { jsx, css } from '@emotion/react'

import { useController } from '@searchspring/snap-preact-components'

import './productcount.css'

export const ProductCount = () => {
    const controller = useController()

    const inlineCount = useMemo(
        () => controller.store.merchandising?.content?.inline?.length ?? 0,
        [controller.store.merchandising?.content?.inline?.length]
    )

    const resultCount = useMemo(
        () => controller.store.pagination.totalResults - inlineCount,
        [controller.store.pagination.totalResults, inlineCount]
    )

    return (
        <div class="product-count">
            <div class="number-of-products">
                <div className="number-of-products__count" role="status" aria-live="polite">
                    {resultCount == 1 ?
                        `${resultCount}
                        ${
                            controller.store.config?.id == 'articles' ?
                            window.Resources.searchspring.results.resultsArticlesCountSingular :
                            window.Resources.searchspring.results.resultsProductsCountSingular
                        }`:
                        `${resultCount}
                        ${
                            controller.store.config?.id == 'articles' ?
                            window.Resources.searchspring.results.resultsArticlesCountPlural :
                            window.Resources.searchspring.results.resultsProductsCountPlural
                        }
                    `}
                </div>
            </div>
        </div>
    )
}
